import { render, staticRenderFns } from "./LicenciaOficialColectivaTabContent.vue?vue&type=template&id=1d6ee764&scoped=true"
import script from "./LicenciaOficialColectivaTabContent.vue?vue&type=script&lang=js"
export * from "./LicenciaOficialColectivaTabContent.vue?vue&type=script&lang=js"
import style0 from "./LicenciaOficialColectivaTabContent.vue?vue&type=style&index=0&id=1d6ee764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ee764",
  null
  
)

export default component.exports